import React, {Component} from "react";
import Select from "../../../local_node_modules/react-select";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import DBSAuthModal from "../../evoucher/DBSAuthModal";

class DefaultDbsHeaders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultHeaders: {},
            type: null
        }
        this.getGelirKayitAltTuruOpt = this.getGelirKayitAltTuruOpt.bind(this);
        this.onChange = this.onChange.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.onSave = this.onSave.bind(this);
        this.fetchDefaultHeaders = this.fetchDefaultHeaders.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
    }

    componentDidMount() {
        this.fetchDefaultHeaders();
    }

    fetchData(){
        let self = this;
        let params = {
            url: self.state.type === "eBelge" ? `/dbs/gelirbelgeislemleri/fetchSelectData` : (self.state.type === "eArchive" ? `/dbs/gelirbelgeislemleri/fetchSelectData` : (self.state.type === "eInvoice" ? `/dbs/gelirbelgeislemleri/fetchSelectData` : `/dbs/gelirbelgeislemleri/fetchSelectData`)),
            method: 'post',
        };
        self.setState({loading: true});
        request(params)
            .then(function (response){
                let data = response.data;
                let satisTuruKodlari = data.satisTuruKodlari.body;
                let gelirKayitTuru = data.gelirKayitTuru.body;
                let gelirKayitAltTuru = data.gelirKayitAltTuru.body;
                let withHoldingCodes = data.withHoldingCodes.body;
                let stoppageCode = data.stoppageCode.body;
                let {taxOffices, faaliyetKodlari, hizmetsatisialtturu} = data;
                self.setState({stoppageCode, satisTuruKodlari, gelirKayitAltTuru, gelirKayitTuru, withHoldingCodes, taxOffices, faaliyetKodlari, hizmetsatisialtturu, loading: false});
            }).catch(function (error) {
            if (error.response && error.response.data &&
                error.response.data === 'NOT_FOUND_TOKEN') {
                Alert.error("Token bilgisi bulunamadı, Önce giriş yapmalısınız", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.setState({dbsAuthModal: true});
            }
        });
    }

    onChange(name, value) {
        let defaultHeaders = deepCopyObject(this.state.defaultHeaders);
        let type = deepCopyObject(this.state.type);

        if(name !== "type"){
            defaultHeaders[type][name] = value

            this.setState({defaultHeaders});
            if(name === "gelirKayitTuruKodu"){
                this.getGelirKayitAltTuruOpt();
            }
        }else {
            type = value;
            defaultHeaders[type] = (defaultHeaders[type] === undefined || defaultHeaders[type] === null) ? {} : defaultHeaders[type];
            this.setState({type,defaultHeaders});
            this.fetchData();
        }

    }

    getGelirKayitAltTuruOpt(){

        if(this.state.type === "eBelge" || this.state.type === "eArchive" || this.state.type === "eInvoice" || this.state.defaultHeaders[this.state.type].gelirKayitTuruKodu !== "2"){
            let tur = this.state.gelirKayitAltTuru.filter(altTur =>
                this.state.defaultHeaders[this.state.type] !== undefined && (altTur.gelirKayitTuruKodu === this.state.defaultHeaders[this.state.type].gelirKayitTuruKodu)).map(altTur => ({
                value: altTur.kod,
                label: altTur.kod + "-" + altTur.kayitTuru
            }));
            return tur;
        }else{
            let tur = this.state.hizmetsatisialtturu.map(altTur =>({
                value: altTur.kod,
                label: altTur.kod + "-" + altTur.kayitTuru
            }));
            return tur;
        }
    }

    onSave(){
        let self = this;
        let defaultHeaders = deepCopyObject(self.state.defaultHeaders);
        let data = defaultHeaders[self.state.type];
        data.documentType = this.state.type;
        let params = {
            url: "/dbs/gelirbelgeislemleri/saveDefaultHeaders",
            method: "post",
            data: data
        };
        request(params)
            .then(function (response) {
                Alert.success("Kayıt başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch(function (error) {
            Alert.error("Kayıt başarısız.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        });
    }

    fetchDefaultHeaders(){
        let self = this;
        let params = {
            url: '/dbs/gelirbelgeislemleri/fetchDefaultHeaders',
            method: 'post',
        }
        request(params)
            .then(function (response) {
                let defaultHeaders = deepCopyObject(self.state.defaultHeaders);
                response.data.map(content => {
                    defaultHeaders[content.documentType] = content;
                });
                self.setState({defaultHeaders});
            }).catch(function (error){
            Alert.error(error.data, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        });
    }

    renderOptions(){
        let options = [];
        if (this.isEBelge()){
            options.push({label: "E-Arşiv Belge", value: "eBelge"})
        }if (this.isESMM()){
            options.push({label: "Serbest Meslek Makbuzu", value: "sVoucher"})
        }if (this.isEArsiv()){
            options.push({label: "E-Arşiv Fatura", value: "eArchive"})
        }if (this.isEFatura()){
            options.push({label: "E-Fatura", value: "eInvoice"});
        }
        return options;
    }

    isEBelge() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIVBESBINOTUZBIN;
    }

    isESMM() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESMM;
    }

    isEFatura() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EFATURA;
    }

    isEArsiv() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIV;
    }

    render() {
        let defaultHeaders = deepCopyObject(this.state.defaultHeaders);
        let type = deepCopyObject(this.state.type);

        let satisTuruKodlari = this.state.satisTuruKodlari;
        let gelirKayitTuru = this.state.gelirKayitTuru;
        return (
            <div className={'FormRenk'}>
                <div className={"row"}>
                    <div className={"col-md-3"}>
                        <label>Varsayılanı eklemek istediğiniz hizmet: </label>
                    </div>

                    <div className={"col-md-4"} style={{paddingRight: '100px'}}>
                        <Select
                            clearable={false}
                            className="select-control"
                            value={this.state.type !== undefined && this.state.type}
                            placeholder="Seçiniz..."
                            onChange={(e) => this.onChange("type", e.value)}
                            options={this.renderOptions()}
                        />
                    </div>
                    <div className={"col-md-2"}></div>
                    <div className={"col-md-2"}>
                        <button type="button" data-toggle="tooltip" data-placement="top"
                                style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', float: 'right'}}
                                rel="tooltip" className="TekBtn kaydet btn-icon"
                                onClick={() => {
                                    this.onSave()
                                }}>Kaydet
                        </button>
                    </div>

                </div>

                {satisTuruKodlari && satisTuruKodlari.length !== 0 &&
                <div>
                    <table className="" style={{textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', marginTop: '10px', paddingRight: '50px'}}>
                        <thead>
                        <tr style={{backgroundColor: '#94bef3', borderRadius: '10px'}}>
                            <td>Satış Türü</td>
                            <td>Gelir Kayıt Türü</td>
                            <td>Gelir Kayıt Alt Türü</td>
                            <td>Faaliyet Kodu</td>
                            <td>Stopaj Kodu</td>
                            <td>Tevkifat Kodu</td>

                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <Select
                                    clearable={false}
                                    className="select-control"
                                    value={defaultHeaders[type] !== undefined && defaultHeaders[type].satisTuruKodu}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChange("satisTuruKodu", e.value)}
                                    options={
                                        satisTuruKodlari.map(satis => ({
                                            value: satis.kod,
                                            label: satis.kod + "-" + satis.aciklama
                                        }))
                                    }
                                />
                            </td>
                            <td>
                                <Select
                                    clearable={false}
                                    className="select-control"
                                    value={defaultHeaders[type] !== undefined && defaultHeaders[type].gelirKayitTuruKodu}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChange("gelirKayitTuruKodu", e.value)}
                                    options={
                                        gelirKayitTuru.map(gelirKayit => ({
                                            value: gelirKayit.kod,
                                            label: gelirKayit.kod + "-" + gelirKayit.kayitTuru
                                        }))
                                    }
                                />
                            </td>
                            <td>
                                <Select
                                    clearable={false}
                                    className="select-control"
                                    disabled={defaultHeaders[type] !== undefined && defaultHeaders[type].gelirKayitTuruKodu === undefined}
                                    value={defaultHeaders[type] !== undefined && defaultHeaders[type].gelirKayitAltTuruKodu}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChange("gelirKayitAltTuruKodu", e.value)}
                                    options={this.getGelirKayitAltTuruOpt()}
                                />
                            </td>
                            <td>
                                <Select
                                    clearable={false}
                                    className="select-control"
                                    value={defaultHeaders[type] !== undefined && defaultHeaders[type].naceKodu}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChange("naceKodu", e.value)}
                                    options={
                                        this.state.faaliyetKodlari.map(faaliyet => ({
                                            value: faaliyet.faaliyetKodu,
                                            label: faaliyet.faaliyetKodu + "-" + faaliyet.faaliyetAdi
                                        }))
                                    }
                                />
                            </td>
                            <td>
                                <Select
                                    clearable={false}
                                    className="select-control"
                                    value={defaultHeaders[type] !== undefined && defaultHeaders[type].stopajKodu}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChange("stopajKodu", e.value)}
                                    options={
                                        (this.state.type === "eBelge" || this.state.type === "eArchive" || this.state.type === "eInvoice") ?
                                            this.state.stoppageCode.map(codes => ({
                                                value: codes.kod,
                                                label: codes.kod + "-" + codes.aciklama
                                            })) :
                                            this.state.stoppageCode.filter(codes => codes.grup === "Serbest Meslek").map(codes => ({
                                                value: codes.kod,
                                                label: codes.kod + "-" + codes.aciklama
                                            }))

                                    }
                                />
                            </td>
                            <td>
                                <Select
                                    clearable={false}
                                    className="select-control"
                                    value={defaultHeaders[type] !== undefined && defaultHeaders[type].kismiTevkifatKodu}
                                    placeholder="Seçiniz..."
                                    onChange={(e) => this.onChange("kismiTevkifatKodu", e.value)}
                                    options={this.state.withHoldingCodes.map(codes => ({
                                        value: codes.kod,
                                        label: codes.kod + "-" + codes.aciklama
                                    }))
                                    }
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                }

                {this.state.dbsAuthModal &&
                <DBSAuthModal
                    from={this.state.from}
                    toggleModal={(dbsAuthModal) => this.setState({dbsAuthModal},() => this.fetchData())}
                    modal={this.state.dbsAuthModal}/>
                }

            </div>
        )
    }

}
export default DefaultDbsHeaders;